(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-faqs-unificada"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initFaqTabs(root) {
      var tablists = root.querySelectorAll('[data-faq-tabs]');
      tablists.forEach(function (tablist) {
        if (tablist.dataset.faqTabsInit === 'true') return;
        tablist.dataset.faqTabsInit = 'true';

        var section = tablist.closest('.faq-uni');
        if (!section) return;

        var tabs = Array.prototype.slice.call(tablist.querySelectorAll('[role="tab"]'));
        if (!tabs.length) return;

        function panelFor(tab) {
          var id = tab.getAttribute('aria-controls');
          return id ? section.querySelector('#' + (window.CSS && CSS.escape ? CSS.escape(id) : id)) : null;
        }

        function activate(tab, setFocus) {
          tabs.forEach(function (t) {
            var selected = t === tab;
            t.setAttribute('aria-selected', selected ? 'true' : 'false');
            t.setAttribute('tabindex', selected ? '0' : '-1');
            t.classList.toggle('is-active', selected);
            var panel = panelFor(t);
            if (panel) {
              if (selected) {
                panel.removeAttribute('hidden');
              } else {
                panel.setAttribute('hidden', '');
              }
            }
          });
          if (setFocus) tab.focus();
        }

        tabs.forEach(function (tab, index) {
          tab.addEventListener('click', function () {
            activate(tab, false);
          });
          tab.addEventListener('keydown', function (e) {
            var key = e.key;
            var newIndex = null;
            if (key === 'ArrowRight' || key === 'ArrowDown') {
              newIndex = (index + 1) % tabs.length;
            } else if (key === 'ArrowLeft' || key === 'ArrowUp') {
              newIndex = (index - 1 + tabs.length) % tabs.length;
            } else if (key === 'Home') {
              newIndex = 0;
            } else if (key === 'End') {
              newIndex = tabs.length - 1;
            }
            if (newIndex !== null) {
              e.preventDefault();
              activate(tabs[newIndex], true);
            }
          });
        });

        // JS toma el control: oculta todos los paneles menos el activo por
        // defecto (marcado en el markup). Hasta aquí, todos estaban visibles.
        var defaultTab = tabs.filter(function (t) {
          return t.getAttribute('aria-selected') === 'true';
        })[0] || tabs[0];
        activate(defaultTab, false);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        initFaqTabs(document);
      });
    } else {
      initFaqTabs(document);
    }

    document.addEventListener('shopify:section:load', function (e) {
      initFaqTabs(e.target);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
